<template>
  <div :class="componentClasses">
    {{ letter }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  shade: {
    type: String,
    required: false,
    default: '',
  },
  letter: {
    type: String,
    required: true,
  },
});

const componentClasses = computed(() => [
  'stk-keystroke',
  props.shade ? `shaded shade-${props.shade}` : '',
]);
</script>

<style>
.stk-keystroke {
  --h: var(--stk-info-h);
  --s: var(--stk-info-s);
  --l: var(--stk-info-l);
  border-radius: 0.25rem;
  background: hsl(var(--h), var(--s), 90%);
  box-shadow: 0px 1px 0px 1px hsl(var(--h), var(--s), 75%);
  color: hsl(var(--h), var(--s), 50%);
  font-size: 0.75rem;
  font-family: monospace;
  font-weight: 700;
  height: 1.125rem;
  width: 1.125rem;
  display: inline-flex;
  vertical-align: top;
  justify-content: center;
  text-align: center;
  align-items: center;
  line-height: 1.125rem;

  &.shade-success {
    --h: var(--stk-success-h);
    --s: var(--stk-success-s);
  }

  &.shade-info {
    --h: var(--stk-info-h);
    --s: var(--stk-info-s);
  }

  &.shade-warning {
    --h: var(--stk-warning-h);
    --s: var(--stk-warning-s);
  }

  &.shade-danger {
    --h: var(--stk-danger-h);
    --s: var(--stk-danger-s);
  }
}
</style>
